export class GenericCache {
    constructor() {
        this.valuesByCacheKey = new Map();
    }
    has(key) {
        return this.valuesByCacheKey.has(key);
    }
    get(key) {
        return this.valuesByCacheKey.get(key) || null;
    }
    set(key, value) {
        this.valuesByCacheKey.set(key, value);
    }
    del(key) {
        this.valuesByCacheKey.delete(key);
    }
}
//# sourceMappingURL=generic-cache.js.map